import {
	BookOpen,
	FlaskConical,
	Images,
	LayoutDashboard,
	Package,
	Settings,
	Sparkles,
	type LucideIcon,
} from "lucide-react";

export interface NavItem {
	to: string;
	label: string;
	icon: LucideIcon;
	end: boolean;
	/** Secondary destinations that belong to the item above them. */
	children?: Omit<NavItem, "icon" | "children">[];
}

export interface NavGroup {
	label: string | null;
	items: NavItem[];
	/** Pinned to the foot of the nav rather than flowing after the group above. */
	bottom?: boolean;
}

export const NAV_GROUPS: NavGroup[] = [
	{
		label: null,
		items: [
			{ to: "/", label: "Overview", icon: LayoutDashboard, end: true },
			{ to: "/campaigns", label: "Campaigns", icon: Sparkles, end: false },
			{ to: "/content", label: "Content", icon: Images, end: false },
			{ to: "/experiments", label: "A/B tests", icon: FlaskConical, end: false },
		],
	},
	{
		label: "Catalog",
		items: [
			{
				to: "/products",
				label: "Products",
				icon: Package,
				end: false,
				children: [
					{ to: "/collections", label: "Collections", end: false },
					{ to: "/locations", label: "Locations", end: false },
				],
			},
		],
	},
	{
		label: null,
		bottom: true,
		items: [
			{ to: "/docs", label: "Docs & guides", icon: BookOpen, end: false },
			{ to: "/settings", label: "Settings", icon: Settings, end: false },
		],
	},
];

export const pageTitle = (pathname: string): string => {
	if (pathname.startsWith("/campaigns")) return "Campaigns";
	if (pathname.startsWith("/content")) return "Content";
	if (pathname.startsWith("/experiments")) return "A/B tests";
	if (pathname.startsWith("/products")) return "Products";
	if (pathname.startsWith("/collections")) return "Collections";
	if (pathname.startsWith("/locations")) return "Locations";
	if (pathname.startsWith("/docs")) return "Docs & guides";
	if (pathname.startsWith("/settings")) return "Settings";
	return "Overview";
};
